// import shallow from 'zustand/shallow'
import { create } from 'zustand'
import { IssnCheckResult, ISubmitRespApplication } from '../lib/interfaces/models'
// import { SnackbarContentProps } from '@mui/material'


interface StoreVars {
  guardian1Checked?: boolean
  setGuardian1Checked: (cb: boolean) => void
  studentSsnResult: IssnCheckResult
  setStudentSsnResult: (result: IssnCheckResult) => void
  hideSubmit: boolean
  setHideSubmit: (flag: boolean) => void
  snackText?: string
  setSnackText: (c: string) => void
  apiReturn: ISubmitRespApplication
  setApiReturn: (apidata: ISubmitRespApplication) => void
  returnKeys: IReturnKeys
  setReturnKeys: (retKeys: IReturnKeys) => void
}

export interface IReturnKeys {
  nr?: string
  code?: string
  key?: string
}

export const useAppStore = create<StoreVars>((set) => ({

  returnKeys: <IReturnKeys>{nr: '', code: '', key: ''},
  setReturnKeys: (retKeys: IReturnKeys) => {
    set({returnKeys: retKeys})
  },
  apiReturn: {
    applicationId: " ",
    email: 0,
    email1: "",
    media: 0,
    name: "",
    prev: 0,
    serial: 0,
    ssid: "",
    status: 0,
    time: ""
  },
  setApiReturn: (apidata: ISubmitRespApplication) => {
    set({ apiReturn: apidata })
  },

  studentSsnResult: <IssnCheckResult>{ ssn: false, error: false, minor: false },
  setStudentSsnResult: (res: IssnCheckResult) => {
    set({ studentSsnResult: res })
  },

  snackText: "",
  setSnackText: (c: string) => {
    set({ snackText: c })
  },


  guardian1Checked: false,
  setGuardian1Checked: (cb) => {
    set({ guardian1Checked: cb ? true : false })
  },

  hideSubmit: false,
  setHideSubmit: (flag) => {
    set({ hideSubmit: flag ? true : false })
  },

}))
